import React from "react";
// import smiley from "assets/smily.png";
import { withPage } from "hoc/WithPages";

const Blogs = () => (
	<div>
		<h1 className="text-4xl font-bold mb-4">
			Blogs and News<span className="text-primary">.</span>
		</h1>
		<div className="mb-48">
			<p>Blogs and news page placeholder</p>
		</div>
	</div>
);

export default withPage(Blogs);
